import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import AdminUserRow from './AdminUserRow';
import PagedPicker from './PagedPicker';

/**
 * The whole list of accounts, for when searching is not what you want.
 *
 * Picking people opens the editing mask beneath — the same one the search
 * results open, one per selected account.
 */
function AdminUserBrowser({ users, groups, assignableGroups, onChanged }) {
  const { t } = useTranslation();

  const [selectedIds, setSelectedIds] = useState([]);

  // Selection survives paging: picking someone on page one and someone on page
  // two is a reasonable thing to do, and their masks stack up below.
  const selectedUsers = users.filter((user) =>
    selectedIds.includes(user.userId),
  );

  function toggle(userId) {
    setSelectedIds((current) =>
      current.includes(userId)
        ? current.filter((id) => id !== userId)
        : [...current, userId],
    );
  }

  return (
    <div className="admin-user-browser">
      <PagedPicker
        items={users}
        getKey={(user) => user.userId}
        selectedKeys={selectedIds}
        onToggle={toggle}
        renderPrimary={(user) =>
          [user.firstName, user.lastName].filter(Boolean).join(' ') ||
          user.username
        }
        renderSecondary={(user) => `@${user.username}`}
        renderBadge={(user) =>
          user.isActive ? null : (
            <span className="admin-user-status inactive">
              {t('adminPanel.statusInactive')}
            </span>
          )
        }
      />

      {selectedUsers.length > 0 && (
        <div className="admin-user-list admin-user-selection">
          {selectedUsers.map((user) => (
            <AdminUserRow
              key={user.userId}
              user={user}
              groups={groups}
              assignableGroups={assignableGroups}
              isExpanded
              onToggle={() => toggle(user.userId)}
              onChanged={onChanged}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default AdminUserBrowser;
